var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Authorize"},[(_vm.hasAuthorization['can'])?[_vm._t("default")]:(!_vm.noFallback)?[_vm._t("fallback",function(){return [_c('authorized-fallback',{attrs:{"permission":_vm.hasAuthorization}})]})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }